module.exports = __webpack_public_path__ + "img/edge_patrimoine_chateaux.383e8c29.svg";